@if (video(); as item) {
  <div class="rw-video-modal" (click)="close()">
    <!-- Clicks inside the frame stay inside it; only the dimmed area around
         the player closes the pop-up. -->
    <div class="rw-video-modal__dialog" role="dialog" aria-modal="true"
         [attr.aria-label]="item.title" (click)="$event.stopPropagation()">
      <button #closeButton type="button" class="rw-video-modal__close"
              aria-label="Close video" (click)="close()">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
          <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
        </svg>
      </button>

      <div class="rw-video-modal__frame">
        @if (item.kind === 'mp4') {
          <!-- An upload from the CMS. The URL was checked as https in
               VideoModalService; Angular's own URL sanitiser runs on [src] and
               [poster] as well. Any shape fits: the clip is letterboxed inside
               the 16:9 frame rather than cropped. Opened by a click, so the
               browser allows it to start with sound. -->
          <video #mp4Player class="rw-video-modal__player rw-video-modal__player--mp4"
                 [src]="item.url" [attr.poster]="item.poster" [attr.aria-label]="item.title"
                 controls autoplay playsinline preload="auto"></video>
        } @else {
          <!-- appTrustedSrc sets the src as an attribute, so no DomSanitizer
               bypass is needed; embedUrl is built from a validated ID only. -->
          <iframe class="rw-video-modal__player" [appTrustedSrc]="embedUrl()"
                  [title]="item.title" frameborder="0"
                  allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
                  allowfullscreen></iframe>
        }
      </div>
    </div>
  </div>
}
